const fallbackLandings = {
  "juego-de-pistola-rociadora-para-inodoro": {
    productId: "romi-ai-1",
    product: "Juego de Pistola Rociadora para Inodoro",
    subtitle: "Higiene personal superior y limpieza eficiente",
    images: ["hero-1785774894282.png", "problema-1785774917638.png", "solucion-1785774930219.png", "oferta-1785774946554.png", "cta-final-1785774984000.png"].map((name) => `/landings/juego-pistola-rociadora/${name}`),
    extraImage: "https://i.ibb.co/MDPQ0288/Captura-de-pantalla-2026-08-03-200945.png",
    offers: [{ qty: 1, price: 27.99 }, { qty: 2, price: 41.99, featured: true }, { qty: 3, price: 56.99 }],
  },
  "colchon-inflable-premium-para-auto-y-hogar-con-bomba-electrica-2-almohadas": {
    productId: "romi-ai-2",
    product: "Colchón Inflable Premium para Auto",
    subtitle: "Convierte el asiento trasero de tu vehículo en una cómoda cama en minutos",
    images: ["hero-1785887269538.png", "problema-1785887288854.png", "solucion-1785887301896.png", "/romi-commerce-ai/uploads/creatives/2/oferta-1786387176410.png", "cta-final-1785887318553.png"].map((name) => name.startsWith("/") ? name : `/landings/colchon-inflable/${name}`),
    extraImage: "https://i.ibb.co/MDPQ0288/Captura-de-pantalla-2026-08-03-200945.png",
    offers: [{ qty: 1, price: 39.99 }, { qty: 2, price: 64.99, featured: true }],
    marquee: ["DESCANSA CÓMODAMENTE EN CADA VIAJE", "INCLUYE BOMBA ELÉCTRICA", "ENVÍO GRATIS A TODO ECUADOR", "PAGO CONTRA ENTREGA", "COMPRA SEGURA"],
    ctas: ["PEDIR AHORA Y PAGAR AL RECIBIR", "QUIERO MI COLCHÓN EN OFERTA", "QUIERO VIAJAR CÓMODAMENTE", "APROVECHAR LA PROMOCIÓN", "COMPRAR AHORA Y RECIBIR EN CASA"],
    theme: { page: "#541600", ink: "#fff7ed", accent: "#f2c94c", accentInk: "#171717", border: "#f2c94c", form: "#fff7ed", formInk: "#25110a" },
  },
};

export function getFallbackCampaignLanding(slug) {
  return fallbackLandings[slug] || null;
}

export default fallbackLandings;
